import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { Link } from "react-router-dom";  // Import Link from react-router-dom
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Light from 'components/headers/light';
import LightAdmin from 'components/headers/lightAdmin';
import Footerr from "components/footers/Footer";
import ScrollToTop from "components/ScrollToTop";
import { useTranslation } from "react-i18next";

const ImageBox = styled.div`
  ${tw`relative rounded-2xl`}
  height: 260px;
  width: 100%;
  border-radius: 16px;
  overflow: hidden; /* clip image corners */
  box-shadow: 0 6px 12px rgba(0,0,0,0.06);
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover; /* fill box nicely */
  border-radius: 16px; /* ensure rounded corners on the image itself */
  display: block;
`;

const HeartBtn = styled.button`
  ${tw`absolute rounded-full flex items-center justify-center`}
  top: 12px;
  right: 12px;
  width: 36px; height: 36px;
  background: #ffffff;
  box-shadow: 0 6px 12px rgba(0,0,0,0.08);
  border: 0;
  z-index: 2;
`;
const QuickView = styled.span`
  ${tw`absolute rounded-full text-sm`}
  bottom: 12px;
  right: 12px;
  padding: 6px 12px;
  background: #ffffff;
  color: #edbf03;
  box-shadow: 0 6px 12px rgba(0,0,0,0.08);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  z-index: 2;
`;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap -mx-2`;
const CardContainer = tw.div`mt-10 px-2 w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4`;
const Card = tw(motion.a)`rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0 mb-0`;  // Add mb-0 to remove margin-bottom
const CardButton = tw(PrimaryButtonBase)`
  text-sm flex justify-center items-center mt-4 rounded-full px-10 py-2
`;
const CardButtonContainer = tw.div`
  flex justify-center items-center mt-2 w-auto  /* Reduced margin */
`;
const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`
  text-sm font-bold text-center text-[#000000]
`;
const CardPrice = tw.p`
mt-2 font-semibold text-center text-[#133b8c] text-[14px]
`;
const Textile = ({ heading = "Nos produits",products = [] }) => {
  const role = localStorage.getItem("role"); // Assuming role is saved in localStorage
    const [Textile, setTextile] = useState([]);
  
  useEffect(() => {
    fetch("https://plateformewmg.cloud/api/textile")
      .then((response) => response.json())
      .then((data) => setTextile(Array.isArray(data) ? data : []))
      .catch((error) => console.error("Error fetching products textile:", error));
  }, []);
      const { t, i18n } = useTranslation();
  return (
      <AnimationRevealPage>
                          <ScrollToTop />

          {role === "supplier" ? <Light /> : role === "buyer" ? <LightAdmin /> : <Light />}
     <Container>
      <ContentWithPaddingXl>
        <TabContent>
          {Textile.length > 0 ? (
            Textile.map((card, index) => (
              <CardContainer key={index}>
                <Link to={`/product-details/${card.ProductID}`}>
                  <Card className="group" initial="rest" whileHover="hover" animate="rest">
    <ImageBox>
                        <ProductImage src={`https://plateformewmg.cloud/storage/${card.image}`} alt="" />
                        <HeartBtn title="Wishlist" aria-label="wishlist">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f43f5e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>
                        </HeartBtn>
                        <QuickView>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                          {i18n.language === 'ar' ? 'نظرة سريعة' : t('quick_view', { defaultValue: 'Aperçu rapide' })}
                        </QuickView>
                      </ImageBox>

                    <CardText>
                          <CardPrice>
  {role === "supplier"
    ? `${card.distributeur_price} ${t("currency")}`
    : `${card.user_price} ${t("currency")}`}
</CardPrice>
                      <CardTitle>
          {typeof card.Name === "object"
            ? (card.Name?.[i18n.language] ?? card.Name?.fr ?? card.Name?.ar ?? "")
            : card.Name}
        </CardTitle>
                      <CardButtonContainer>
                        <CardButton>{t("Acheter")} </CardButton>
                      </CardButtonContainer>
                    </CardText>
                  </Card>
                </Link>
              </CardContainer>
            ))
          ) : (
                        <p>{t('loadingAvailableProducts')}</p>
          )}
        </TabContent>
      </ContentWithPaddingXl>
    </Container>
        <Footerr />
        </AnimationRevealPage>
  );
};
export default Textile;
